import React from "react"

import ThemeGallery from "../../components/ThemeGalleryPublic"

const ThemeGalleryPublic = () => (
	<ThemeGallery />
)

export default ThemeGalleryPublic
